import { createContext } from "react";
import { ResultsMenuStore } from "@state/stores/results";

export const ResultsMenuStoreContext = createContext({} as ResultsMenuStore);
